import { render } from "./MTAgency.vue?vue&type=template&id=44043f08&ts=true"
import script from "./MTAgency.vue?vue&type=script&lang=ts"
export * from "./MTAgency.vue?vue&type=script&lang=ts"

import "./MTAgency.vue?vue&type=style&index=0&id=44043f08&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__